import Cascader from 'rsuite/Cascader';
import { useTranslation } from "react-i18next";


const CommodityCascader = ({searchable, size, onChange, placeholder}) => {
    const { t } = useTranslation();

    const commodityOptions = [
        {
          label: t("Beverages, Foods & Plants"),
          children: [
            { value: "non-perishable-foods", label: t("Non-perishable Foods") },
            { value: "water-soft-drinks", label: t("Water, Soft Drinks") },
            { value: "wines", label: t("Still and Sparkling Wines") },
            { value: "spirits-liquors", label: t("Spirits, Liquors") },
            { value: "fresh-frozen-products", label: t("Fresh & Frozen Products") },
            { value: "tobacco", label: t("Tobacco") },
            { value: "plants-flowers-seeds", label: t("Plants, Flowers & Seeds") }
          ]
        },
        {
          label: t("Chemicals & Healthcare"),
          children: [
            { value: "pharmaceutical-goods", label: t("Pharmaceutical Goods") },
            { value: "cosmetics-well-being", label: t("Cosmetics, Well-being Products") },
            { value: "perfumes", label: t("Perfumes") },
            { value: "chemicals-cleaning-products", label: t("Chemicals, Cleaning Products & Drugstore Products") }
          ]
        },
        {
          label: t("Furniture & Accessories"),
          children: [
            { value: "decor-articles", label: t("Decor Articles") },
            { value: "lights", label: t("Lights") },
            { value: "carpets", label: t("Carpets") },
            { value: "curtains-sheets", label: t("Curtains, Sheets") },
            { value: "un-disassembled-furniture", label: t("Un-disassembled Furniture (Home-office)") },
            { value: "ceramics-porcelain-chinaware", label: t("Ceramics, Porcelain & Chinaware") },
            { value: "personal-removal-effects", label: t("Personal/Removal Effects") },
            { value: "collection-items", label: t("Collection Items or Pictures, Mirror, Glass, Artcrafts, Sculpture, Antiques, etc.") }
          ]
        },
        {
          label: t("Industrial Products"),
          children: [
            { value: "metal-products", label: t("Finished and Semi-finished Products (incl. Spare Parts) in Metal") },
            { value: "rubber-plastics-products", label: t("Finished and Semi-finished Products (incl. Spare Parts) in Rubber or Plastics") },
            { value: "wood-products", label: t("Finished and Semi-finished Products (incl. Spare Parts) in Wood or Woodenware") },
            { value: "raw-materials", label: t("Raw Materials (Minerals, Paper, Metal, Wood, Gas & Petroleum)") }
          ]
        },
        {
          label: t("Apparels and Accessories"),
          children: [
            { value: "shoes", label: t("Shoes") },
            { value: "textile-garments-new-clothes", label: t("Textile/Garments, New Clothes (in Parcels)") },
            { value: "fashion-accessories", label: t("Fashion Accessories") },
            { value: "fashion-jewellery", label: t("Fashion Jewellery") },
            { value: "used-clothes", label: t("Used Clothes") },
            { value: "textile-garments-new-clothes-hangers", label: t("Textile/Garments, New Clothes on Hangers") },
            { value: "leather-skins", label: t("Leather, Skins") },
            { value: "jewellery-precious-goods", label: t("Jewellery and Precious Goods (incl. Watches)") }
          ]
        },
        {
          label: t("Building Materials"),
          children: [
            { value: "building-materials", label: t("Building Materials, Doors, Goods out of Stone, Cement") },
            { value: "plastic-tubes-plumbing", label: t("Plastic Tubes, Plumbing Facilities") },
            { value: "hardware-valves-locks", label: t("Hardware, Valves, Locks") },
            { value: "floor-cover", label: t("Floor Cover") },
            { value: "heat-material-boilermaking", label: t("Heat Material and Boilermaking") },
            { value: "lights-lighting-equipment", label: t("Lights, Lighting Equipment & Luminous Advertising") },
            { value: "solar-panels", label: t("Solar Panels") },
            { value: "glass-products", label: t("Glass, Glass Products & Windows") },
            { value: "paint-varnish-glue", label: t("Paint, Varnish and Glue") }
          ]
        },
        {
          label: t("Vehicles, Engines & Spare Parts"),
          children: [
            { value: "automotive-spare-parts", label: t("Automotive Spare Parts") },
            { value: "aeronautics-spare-parts", label: t("Aeronautics Spare Parts") },
            { value: "engines-motors", label: t("Engines/motors") },
            { value: "tires", label: t("Tires") },
            { value: "vehicles-motorbikes-bicycles", label: t("Vehicles incl. Motorbikes & Bicycles") }
          ]
        },
        {
          label: t("Appliances and Materials"),
          children: [
            { value: "medical-appliance", label: t("Medical Appliance") },
            { value: "it-devices", label: t("IT Devices (Computers, Screens)") },
            { value: "digital-media", label: t("CD, DVD & Digital Media") },
            { value: "camping-fishing-equipment", label: t("Camping and Fishing Equipment") },
            { value: "sport-equipment", label: t("Sport Equipment (no Clothes)") },
            { value: "music-instruments-accessories", label: t("Music Instruments and Accessories") },
            { value: "laboratory-optical-material", label: t("Laboratory, Optical & Measurement Material") },
            { value: "electronics-devices-cables", label: t("Electric & Electronics Devices, Cables") },
            { value: "tools", label: t("Tools") },
            { value: "other-appliances-materials", label: t("Others Appliances and Materials") }
          ]
        },
        {
          label: t("Leisure Items"),
          children: [
            { value: "cultural-products", label: t("Cultural Products (Books, Games, etc.)") },
            { value: "corporate-gifts", label: t("Gifts, Corporate Gifts & Advertising Items") },
            { value: "toys-new", label: t("Toys (new)") },
            { value: "toys-used", label: t("Toys (used)") },
            { value: "art-craft-materials", label: t("Creative Leisure, Art & Craft materials") }
          ]
        },
        {
          label: t("Paperboard & Prints"),
          children: [
            { value: "magazines-newspapers", label: t("Magazines, Reviews & Newspapers") },
            { value: "technical-handbook", label: t("Technical Handbook") },
            { value: "books", label: t("Books") },
            { value: "advertising-documents", label: t("Advertising Documents") },
            { value: "stickers", label: t("Stickers") },
            { value: "documents-with-data", label: t("Documents with Data, Letters, Passports, Tickets, Medical, Medical X-Ray") }
          ]
        },
        {
          label: t("Other"),
          value: "other"
        }
      ];

    return(
        <Cascader block
        searchable={searchable}
        size={size}
        data={commodityOptions}
        onChange={onChange}
        placeholder={placeholder}
      />
    );
};

export default CommodityCascader;